/* ============================================================
   TGFM PDP v2 - Slice 52 (JS estratto da Liquid)
   - Legge i dati dal nodo <script type="application/json" data-tgfm-pdp-data>;
   - Gestisce configuratore upgrade RAM/SSD/garanzia: aggiorna prezzo visivo
     e marca le opzioni selezionate;
   - Intercetta submit del form principale: aggiunge il PC al carrello e poi,
     in sequenza, ogni upgrade selezionato come item separato con
     properties._upgrade_for = product.title escapato e truncato a 40 (formato
     identico a snippets/cart-item-list.liquid riga 18-21);
   - Gestisce sticky CTA mobile via IntersectionObserver;
   - Slice 61: ripara il caricamento "Potrebbe interessarti anche" nella PDP v2
     quando Empire usa un section_id dinamico che Shopify serve in 404.
   - Nessuna libreria esterna; nessuna assunzione su jQuery o altri framework.
   ============================================================ */
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-tgfm-pdp]');
    if (!root) return;

    var dataNode = root.querySelector('[data-tgfm-pdp-data]');
    if (!dataNode) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent || '{}');
    } catch (e) {
      console.error('TGFM PDP: JSON data parse error', e);
      return;
    }

    var basePriceCents = parseInt(data.priceCents, 10) || 0;
    var upgradeFor = (typeof data.upgradeFor === 'string') ? data.upgradeFor : '';

    var priceEls = root.querySelectorAll('[data-tgfm-price], .tgfm-pdp__stickycta-price');
    var formatter = (typeof Intl !== 'undefined')
      ? new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' })
      : null;

    var selected = { ram: null, ssd: null, warranty: null, battery: null };

    function propertyInputName(key) {
      return 'properties[' + key + ']';
    }

    function removeFormProperty(key) {
      if (!form || !key) return;
      var existing = form.querySelector('input[name="' + propertyInputName(key) + '"]');
      if (existing) existing.remove();
    }

    function setFormProperty(key, value) {
      if (!form || !key || !value) return;
      removeFormProperty(key);
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = propertyInputName(key);
      input.value = value;
      input.setAttribute('data-tgfm-dynamic-property', key);
      form.appendChild(input);
    }

    function recalc() {
      if (!priceEls.length) return;
      var addCents = 0;
      Object.keys(selected).forEach(function (k) {
        var v = selected[k];
        if (v && typeof v.deltaCents === 'number') addCents += v.deltaCents;
      });
      var totalCents = basePriceCents + addCents;
      var formattedPrice = formatter
        ? formatter.format(totalCents / 100)
        : (totalCents / 100).toFixed(2) + ' EUR';
      Array.prototype.forEach.call(priceEls, function (el) {
        el.textContent = formattedPrice;
      });
    }

    /* Configuratore upgrade */
    var groups = root.querySelectorAll('[data-tgfm-upg-group]');
    Array.prototype.forEach.call(groups, function (group) {
      var groupKey = group.getAttribute('data-tgfm-upg-group');
      group.addEventListener('click', function (ev) {
        var btn = ev.target.closest('.tgfm-pdp__upg-option');
        if (!btn || !group.contains(btn)) return;
        var options = group.querySelectorAll('.tgfm-pdp__upg-option');
        Array.prototype.forEach.call(options, function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        var variantId = btn.getAttribute('data-tgfm-upg-variant');
        var deltaRaw = btn.getAttribute('data-tgfm-upg-delta-cents');
        var deltaCents = parseInt(deltaRaw, 10);
        if (!isFinite(deltaCents)) deltaCents = 0;
        var noteKey = group.getAttribute('data-tgfm-upg-note-key');
        var noteValue = btn.getAttribute('data-tgfm-upg-note-value');
        if (noteKey) removeFormProperty(noteKey);
        if (noteKey && noteValue) setFormProperty(noteKey, noteValue);
        selected[groupKey] = variantId
          ? { variantId: variantId, deltaCents: deltaCents }
          : (noteKey && noteValue)
            ? { noteKey: noteKey, noteValue: noteValue, deltaCents: 0 }
          : null;
        recalc();
      });
    });

    /* Form submit */
    var form = root.querySelector('[data-tgfm-form]');
    var atc = root.querySelector('[data-tgfm-atc]');

    /* TGFM Slice 65 - top CTA: usa il form reale, quindi non duplica logica acquisto. */
    var topCtas = root.querySelectorAll('[data-tgfm-top-atc]');
    Array.prototype.forEach.call(topCtas, function (btn) {
      btn.addEventListener('click', function (ev) {
        ev.preventDefault();
        if (!atc || atc.disabled) return;
        atc.click();
      });
    });

    if (form) {
      form.addEventListener('submit', function (ev) {
        var hasUpgrades = false;
        Object.keys(selected).forEach(function (k) {
          if (selected[k] && selected[k].variantId) hasUpgrades = true;
        });
        if (!hasUpgrades) return; /* submit normale */
        ev.preventDefault();

        if (atc) atc.disabled = true;

        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function (r) {
            if (!r.ok) throw new Error('add main HTTP ' + r.status);
            return r.json();
          })
          .then(function () {
            var queue = [];
            Object.keys(selected).forEach(function (k) {
              if (selected[k] && selected[k].variantId) queue.push(selected[k]);
            });
            return queue.reduce(function (promise, item) {
              return promise.then(function () {
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  body: JSON.stringify({
                    id: parseInt(item.variantId, 10),
                    quantity: 1,
                    properties: { _upgrade_for: upgradeFor }
                  })
                }).then(function (r) {
                  if (!r.ok) throw new Error('add upgrade HTTP ' + r.status);
                  return r.json();
                });
              });
            }, Promise.resolve());
          })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function (err) {
            console.error('TGFM PDP add to cart error', err);
            if (atc) atc.disabled = false;
            /* fallback: redirect comunque al carrello (il PC e stato aggiunto al primo step) */
            window.location.href = '/cart';
          });
      });
    }

    /* Sticky CTA mobile */
    var sticky = root.querySelector('[data-tgfm-sticky]');
    var stickyCta = root.querySelector('[data-tgfm-sticky-cta]');
    if (sticky && atc && typeof IntersectionObserver !== 'undefined') {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            sticky.classList.remove('tgfm-pdp__stickycta--show');
            sticky.setAttribute('aria-hidden', 'true');
          } else {
            sticky.classList.add('tgfm-pdp__stickycta--show');
            sticky.setAttribute('aria-hidden', 'false');
          }
        });
      }, { rootMargin: '0px 0px -20% 0px' });
      io.observe(atc);
      if (stickyCta) {
        stickyCta.addEventListener('click', function (ev) {
          ev.preventDefault();
          if (!atc.disabled) {
            atc.click();
            return;
          }
          atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { atc.focus(); }, 400);
        });
      }
    }
  }

  function initProductRecommendationsBridge() {
    var sectionScript = document.querySelector('script[data-section-type="static-product-recommendations"][data-section-data]');
    var container = document.querySelector('[data-product-recommendations]');
    if (!sectionScript || !container) return;

    var sectionData;
    try {
      sectionData = JSON.parse(sectionScript.textContent || '{}');
    } catch (e) {
      return;
    }

    var productId = sectionData.productId;
    var limit = sectionData.settings && sectionData.settings.limit ? sectionData.settings.limit : 5;
    if (!productId) return;

    function containerNeedsRepair() {
      var text = container.textContent || '';
      if (text.indexOf('[object Object]') !== -1) return true;
      if (!container.querySelector('[data-product-item], .productitem')) return true;
      return false;
    }

    function hideEmptyRecentlyViewed() {
      var recentSection = document.querySelector('.product-recently-viewed--section');
      if (!recentSection) return;
      var recentContainer = recentSection.querySelector('[data-recently-viewed-container]');
      if (!recentContainer) return;
      var hasRecentCards = recentContainer.querySelector('[data-product-item], .productitem, .product-recently-viewed-card');
      if (hasRecentCards) {
        recentSection.classList.remove('hide');
      } else {
        recentSection.classList.add('hide');
      }
    }


    function observeRecentlyViewed() {
      var recentSection = document.querySelector('.product-recently-viewed--section');
      if (!recentSection || typeof MutationObserver === 'undefined') return;
      var recentContainer = recentSection.querySelector('[data-recently-viewed-container]');
      if (!recentContainer) return;
      var observer = new MutationObserver(function () {
        hideEmptyRecentlyViewed();
      });
      observer.observe(recentContainer, { childList: true, subtree: true });
      window.setTimeout(function () {
        observer.disconnect();
        hideEmptyRecentlyViewed();
      }, 12000);
    }

    function repair() {
      if (!containerNeedsRepair()) {
        hideEmptyRecentlyViewed();
        return;
      }

      var url = '/recommendations/products?section_id=static-product-recommendations'
        + '&limit=' + encodeURIComponent(limit)
        + '&product_id=' + encodeURIComponent(productId);

      fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('recommendations HTTP ' + response.status);
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var remoteContainer = doc.querySelector('[data-product-recommendations]');
          if (!remoteContainer) return;

          var remoteText = remoteContainer.textContent || '';
          if (remoteText.indexOf('[object Object]') !== -1) return;

          container.innerHTML = remoteContainer.innerHTML;
          container.setAttribute('data-tgfm-recommendations-loaded', 'true');
          hideEmptyRecentlyViewed();
        })
        .catch(function (err) {
          console.warn('TGFM PDP recommendations bridge:', err);
          if ((container.textContent || '').indexOf('[object Object]') !== -1) {
            container.innerHTML = '';
          }
          hideEmptyRecentlyViewed();
        });
    }

    observeRecentlyViewed();
    repair();
    window.setTimeout(repair, 1200);
    window.setTimeout(hideEmptyRecentlyViewed, 2200);
    window.setTimeout(hideEmptyRecentlyViewed, 4800);
  }

  function boot() {
    init();
    initProductRecommendationsBridge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
